import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { myFirebase, myFirestore } from '../../lib/firebase'
import Loader from '../Loader'
import WelcomeBoard from '../WelcomeBoard/WelcomeBoard'
import './Main.css'
import ChatBoard from './../ChatBoard/ChatBoard'
import { AppString, supportInfo } from './../ChatBox/Const'

class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      isOpenDialogConfirmLogout: false,
      currentPeerUser: null
    }
    this.currentUserId = supportInfo.id
    this.currentUserAvatar = supportInfo.photoUrl
    this.currentUserNickname = supportInfo.nickName
    this.currentUserRole = supportInfo.role
    this.listUser = []
  }

  componentDidMount() {
    this.checkLogin()
  }

  checkLogin = () => {
    this.getListUser()
  }

  getListUser = async () => {
    const result = await myFirestore.collection(AppString.NODE_USERS).get()
    if (result.docs.length > 0) {
      this.listUser = [...result.docs]
      this.setState({ isLoading: false })
    }
  }

  onLogoutClick = () => {
    this.setState({
      isOpenDialogConfirmLogout: true
    })
  }

  doLogout = () => {
    this.setState({ isLoading: true })
    myFirebase
      .auth()
      .signOut()
      .then(() => {
        this.setState({ isLoading: false }, () => {
          localStorage.clear()
          this.props.showToast(1, 'Logout success')
          this.props.history.push('/')
        })
      })
      .catch(function (err) {
        this.setState({ isLoading: false })
        this.props.showToast(0, err.message)
      })
  }

  hideDialogConfirmLogout = () => {
    this.setState({
      isOpenDialogConfirmLogout: false
    })
  }

  onProfileClick = () => {
    this.props.history.push('/profile')
  }

  renderListUser = () => {
    if (this.listUser.length > 0) {
      let viewListUser = []
      this.listUser.forEach((item, index) => {
        if (item.data().id !== this.currentUserId) {

          if (this.currentUserRole && this.currentUserRole !== '') {

            viewListUser.push(
              <button
                key={index}
                className={
                  this.state.currentPeerUser &&
                    this.state.currentPeerUser.id === item.data().id
                    ? 'viewWrapItemFocused'
                    : 'viewWrapItem'
                }
                onClick={() => {
                  this.setState({ currentPeerUser: item.data() })
                }}
              >
                <div
                  className="viewAvatarItem viewAvatarItem-Second"
                  style={{ backgroundColor: item.data().color || 'black' }}
                >
                  {item.data().nickname.toUpperCase().substring(0, 1)}
                </div>
                <div className="viewWrapContentItem">
                  <span className="textItem">{`Nickname: ${
                    item.data().nickname
                    }`}</span>
                  <span className="textItem">{`About me: ${
                    item.data().aboutMe ? item.data().aboutMe : 'Not available'
                    }`}</span>
                </div>
              </button>
            )
          } else if (item.data().role) {
            viewListUser.push(
              <button
                key={index}
                className={
                  this.state.currentPeerUser &&
                    this.state.currentPeerUser.id === item.data().id
                    ? 'viewWrapItemFocused'
                    : 'viewWrapItem'
                }
                onClick={() => {
                  this.setState({ currentPeerUser: item.data() })
                }}
              >
                <div
                  className="viewAvatarItem viewAvatarItem-Second"
                  style={{ backgroundColor: item.data().color || 'black' }}
                // src={item.data().photoUrl && item.data().photoUrl !== '' ? item.data().photoUrl : '/assets/img/avatar.png'}
                // alt="icon avatar"
                >
                  {item.data().nickname.toUpperCase().substring(0, 1)}
                </div>
                <div className="viewWrapContentItem">
                  <span className="textItem">{`Nickname: ${
                    item.data().nickname
                    }`}</span>
                  <span className="textItem">{`About me: ${
                    item.data().aboutMe ? item.data().aboutMe : 'Not available'
                    }`}</span>
                </div>
              </button>
            )
          }

        }
      })
      return viewListUser
    } else {
      return null
    }
  }

  render() {
    return (
      <div>

        {/* Body */}
        <div className="body">
          <div className="viewListUser"> {this.renderListUser()}</div>
          <div className="viewBoard">
            {this.state.currentPeerUser ? (
              <ChatBoard
                currentPeerUser={this.state.currentPeerUser}
                showToast={this.props.showToast}
              />
            ) : (
                <WelcomeBoard
                  currentUserNickname={this.currentUserNickname}
                  currentUserAvatar={this.currentUserAvatar}
                />
              )}
          </div>
        </div>

        {/* Dialog confirm */}
        {this.state.isOpenDialogConfirmLogout ? (
          <div className="viewCoverScreen">
            {this.renderDialogConfirmLogout()}
          </div>
        ) : null}

        {/* Loading */}
        {this.state.isLoading ? (
          <Loader show={true} />
        ) : null}
      </div>
    )
  }

  renderDialogConfirmLogout = () => {
    return (
      <div>
        <div className="viewWrapTextDialogConfirmLogout">
          <span className="titleDialogConfirmLogout">Are you sure to logout?</span>
        </div>
        <div className="viewWrapButtonDialogConfirmLogout">
          <button className="btnYes" onClick={this.doLogout}>
            YES
                    </button>
          <button className="btnNo" onClick={this.hideDialogConfirmLogout}>
            CANCEL
                    </button>
        </div>
      </div>
    )
  }
}

export default withRouter(Main)
